import { render } from "./MaintenanceScreen.vue?vue&type=template&id=d5b27f40&scoped=true&ts=true"
import script from "./MaintenanceScreen.vue?vue&type=script&lang=ts"
export * from "./MaintenanceScreen.vue?vue&type=script&lang=ts"

import "./MaintenanceScreen.vue?vue&type=style&index=0&id=d5b27f40&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5b27f40"]])

export default __exports__